/**
 * Takes an object and returns a new object with all undefined values replaced with null.
 * Useful for ensuring that all values in an object are serializable.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();export function replaceUndefinedValuesWithNull<
  T extends Record<string, unknown>,
>(object: T) {
  return Object.fromEntries(
    Object.entries(object).map(([key, value]) => [key, value ?? null]),
  )
}
